import React from "react";
import {
  Box,
  Stack,
  Dialog,
  Button,
  TextField,
  DialogTitle,
  DialogContent,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

const GateForm = ({
  open,
  formValue,
  isDisabled,
  errorMessage,
  handleClose,
  handleInputChange,
  findDuplicateGate,
}) => {
  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <Box className="flex justify-between">
          <DialogTitle className="text-[#312C41] !text-[16px] !font-semibold">
            Gate/Booth
          </DialogTitle>

          <CancelRoundedIcon
            onClick={handleClose}
            className="bg-[white] !text-[#344767] !text-[1.7rem] !outline-none p-4 cursor-pointer"
          />
        </Box>

        <DialogContent>
          <form onSubmit={findDuplicateGate}>
            <Stack spacing={4}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12}>
                  <TextField
                    required
                    fullWidth
                    name="name"
                    type="text"
                    id="outlined-required"
                    label="Gate Name"
                    size="small"
                    value={formValue.name}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12}>
                  <FormControl required fullWidth size="small">
                    <InputLabel id="demo-simple-select-required-label">
                      Gate type
                    </InputLabel>
                    <Select
                      name="gateType"
                      label="Gate type"
                      id="demo-simple-select-required"
                      value={formValue.gateType}
                      onChange={handleInputChange}
                      defaultValue={formValue.gateType}
                    >
                      <MenuItem value="ENTRY">Entry</MenuItem>
                      <MenuItem value="EXIT">Exit</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={6} md={6} sm={12}>
                  <TextField
                    required
                    fullWidth
                    name="description"
                    type="text"
                    id="outlined-required"
                    label="Description"
                    size="small"
                    value={formValue.description}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12}>
                  <TextField
                    required
                    fullWidth
                    name="gateNo"
                    type="number"
                    id="outlined-required"
                    label="Gate Number"
                    size="small"
                    value={formValue.gateNo}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>

              <Typography variant="subtitle2" className="text-[#DD2121]">
                {errorMessage}
              </Typography>

              <Button
                disabled={isDisabled}
                // onClick={findDuplicateGate}
                type="submit"
                sx={{
                  textTransform: "none",
                  background: isDisabled
                    ? "gray"
                    : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
                  color: "white",
                  "&:hover": {},
                }}
              >
                {formValue?.id ? "Update" : "Submit"}
              </Button>
            </Stack>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GateForm;
